import imgCongrats from "../../../../img/congrats.png?width=128px"
import sadFace from "../../../../img/sad.png?width=128px"
import I18n from "../../../i18n";
import { EStatusEndQuiz, IRecordObj } from "../../../interfaces/quiz";


export default function finalQuiz(status:EStatusEndQuiz,record:IRecordObj):string{
    let msgFinal = (
        status==EStatusEndQuiz.noQuestion?
        //`<h3 class="msg-final">${I18n.apply("Parabens acertaste todas as nossas questões")}</h3>`:
        `<h3 class="msg-final"></h3>`:
        `<h3 class="msg-end">${status==EStatusEndQuiz.timeEnd?I18n.apply("Tempo esgotado"):I18n.apply("Resposta errada")}</h3>`
    );

    return `
        <div id="quiz-final">
            <h2 class="title-main">${I18n.apply("Fim do Quiz")}</h2>
            <img src="${status==EStatusEndQuiz.noQuestion?imgCongrats:sadFace}" alt="img-congrats" class="img-congrats">
            ${msgFinal}
            <h4 class="total-points"><b>${I18n.apply("Total de Pontos")}:</b><span class="total">${record.points}</span></h4>
            <div class="new-record ${record.status?"":"d-none"}">
                <h4 class="title">${I18n.apply("Novo Record")}</h4>
                <h5 class="ranking">${record.place}˚ ${I18n.translate("lugar")}</h5>
                <input class="input-name" type="text" id="name-player" placeholder="${I18n.translate("seu nome")}...">
                <button type="button" class="sav-record" disabled>${I18n.apply("salvar")}</button>
            </div>
            <div class="options">
                <button type="button" class="btn-again">${I18n.apply("responder novamente")}</button>
                <button type="button" class="btn-back">${I18n.apply("sair")}</button>
            </div>
        </div>
    `;
}